import { Box, Grid, Stack, styled, Typography } from '@mui/material';

export const AssemblyEditContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: row;
  padding: 0 !important;
`;

export const AssemblyEditContentContainer = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 30px 0 30px;
  align-items: flex-start;
`;

export const ActionButtonsContainer = styled(Stack)`
  flex-shrink: 0;
`;

export const AssemblyNameText = styled(Typography)`
  padding-right: 16px;
`;

export const SidebarContainer = styled(Box)`
  display: flex;
  position: relative;
  border-right: 1px solid black;
  width: 340px;
`;

export const GridContainer = styled(Grid)`
  align-items: center;
  direction: row;
  margin-top: 30px;
`;
